

import React from 'react';
import ReactDOM from 'react-dom';
import { LoaderBackdrop, SpinLoader } from './styles';

const LazyLoader: React.FC = () => {
  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(
    <LoaderBackdrop>
      <SpinLoader />
    </LoaderBackdrop>,
    document.body
  );
};

export default LazyLoader;